import React, { createContext, useContext, useState } from "react";

type SessionExpiryReason = "default" | "inactivity";

type AuthContextType = {
  sessionExpired: boolean;
  expiryReason: SessionExpiryReason;
  triggerSessionExpiry: (reason?: SessionExpiryReason) => void;
};

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [sessionExpired, setSessionExpired] = useState(false);
  const [expiryReason, setExpiryReason] =
    useState<SessionExpiryReason>("default");

  const triggerSessionExpiry = (reason: SessionExpiryReason = "default") => {
    setExpiryReason(reason);
    setSessionExpired(true);
  };

  return (
    <AuthContext.Provider
      value={{ sessionExpired, expiryReason, triggerSessionExpiry }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuthContext must be used within an AuthProvider");
  }
  return context;
};

let externalTrigger: (() => void) | null = null;

export const setExternalTrigger = (callback: () => void) => {
  externalTrigger = callback;
};

export const callExternalTrigger = () => {
  if (externalTrigger) externalTrigger();
};
